<template>
  <div id="modifierGroupEdit">
    <div class="container">

      <ModifierNavigation></ModifierNavigation>

      <div class="page-title" v-if="data">
        <span class="name">{{ $to(data.name) }}</span>
        <button class="save btn btn-primary" @click="save"
          v-if="$store.getters.loggedUserCanSaveInventory">{{ $t("save") }}</button>
      </div>

      <Tabs>
        <TabSection :title="$t('modifiers.group_information')">
          <div class="columns">
            <div class="column">
              <div class="group">
                <LocalizedInput :title="$t('internal_name')" :translate="data.name" />
              </div>
              <div class="group">
                <LocalizedInput :title="$t('display_name')" :translate="data.description" />
              </div>
            </div>
            <div class="column">
              <div class="group">
                <label>{{ $t('modifiers.minimum') }} ({{ $t('optional') }})</label>
                <input type="number" v-model="data.min" min="1">
              </div>
              <div class="group">
                <label>{{ $t('modifiers.maximum') }} ({{ $t('optional') }})</label>
                <input type="number" v-model="data.max" min="1">
              </div>
            </div>
          </div>
          <div class="group">
            <ListMultiSelect :bank="modifierSelection" :bankTitle="$t('modifiers.list')" :selected="data.modifiers"
              :selectedTitle="$t('modifiers.list_selected')"></ListMultiSelect>
          </div>

          <InventoryUsagePanel v-if="$route.query.id" type="modifier-group" :id="$route.query.id"></InventoryUsagePanel>
        </TabSection>
      </Tabs>

      <div class="footer-actions" v-if="$store.getters.loggedUserCanSaveInventory">
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import ModifierNavigation from "@/components/modifiers/Navigation";
  import ListMultiSelect from '@/components/tools/ListMultiSelect.vue';
  import { mapActions } from "vuex";
  import LocalizedInput from "@/components/tools/LocalizedInput";

  export default {
    name: "ModifierGroupEdit",

    components: { ModifierNavigation, ListMultiSelect, LocalizedInput },

    data() {
      return {
        inventory: null,
        modifierSelection: [{
          id: null,
          name: { fr: "", en: "" }
        }],
        data: {
          id: null,
          description: { fr: "", en: "" },
          name: { fr: "", en: "" },
          min: null,
          max: null,
          modifiers: []
        }
      }
    },

    computed: {
      inventoryReference() {
        return this.$store.state.contextCompany ? this.$store.state.contextCompany.nameCanonical : this.inventory.id;
      }
    },

    validate: {
      "data.name.fr": {
        required: false
      }
    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;
      let modifierGroupId = this.$route.query.id;

      this.$store.commit('showSpinner', true);

      Promise
        .all([
          modifierGroupId ? this.getModifierGroup({ inventoryId: this.inventoryReference, id: modifierGroupId }) : Promise.resolve(),
          this.getModifiers({ inventoryId: this.inventoryReference }),
        ])
        .then(([modifierGroup, modifiers]) => {
          let dataModifiers = [];
          if (modifierGroupId) {
            this.data.id = modifierGroup.id;
            this.data.name = modifierGroup.name;
            this.data.min = modifierGroup.min;
            this.data.max = modifierGroup.max;
            this.data.description = modifierGroup.description || { fr: "", en: "" };
            dataModifiers = modifierGroup.modifiers;
          }
          this.modifierSelection = modifiers
            .map(c => ({
              id: c.id,
              name: c.name,
              note: c.note
            }));
          this.data.modifiers = this.modifierSelection.filter(m => dataModifiers.indexOf(m.id) > -1);
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.$store.commit('showSpinner', false);

          if (this.$store.getters.isBranchContextInventory) {
            window.lockFields(this.$store.getters.getOverloadableFields);
          } else if (!this.$store.getters.loggedUserCanModifyInventory) {
            window.lockFields();
          }
        });
    },

    watch: {
      "$store.getters.isBranchContextInventory"(newValue) {
        if (newValue) {
          window.lockFields(this.$store.getters.getOverloadableFields);
        }
      }
    },

    methods: {

      ...mapActions(["getModifierGroup", "getModifiers", "saveModifierGroup", "createModifierGroup"]),

      async save() {
        if (!this.$validate.valid()) {
          toast(this.$t("branch.error.required"), "warning");
          this.$validate.validateAllOnce();
          return;
        }
        this.$store.commit("showSpinner", true);
        let copy = JSON.parse(JSON.stringify(this.data));
        copy.modifiers = copy.modifiers.map(m => m.id);
        if (!copy.min || copy.min <= 0) {
          copy.min = null;
        }
        if (!copy.max || copy.max <= 0) {
          copy.max = null;
        }
        if (this.data.id) {
          let response = await this.saveModifierGroup({ inventoryId: this.inventoryReference, itemId: this.data.id, data: copy });
          if (!response) {
            toast(this.$t("modifiers.error.save"), "error");
            this.$store.commit("showSpinner", false);
            return;
          }
        } else {
          let response = await this.createModifierGroup({ inventoryId: this.inventoryReference, data: copy });
          if (!response) {
            toast(this.$t("modifiers.error.save"), "error");
            this.$store.commit("showSpinner", false);
            return;
          }
        }
        this.$store.commit("showSpinner", false);
        this.$router.push(this.$router.buildContext("/modifier-groups"));
        toast(this.$t("modifiers.success"), "success");
      }
    }

  }
</script>

<style lang="scss" scoped>
  #modifierGroupEdit {
    display: flex;
  }
</style>